import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ThingSettingsInterface} from '@app/app/shared/interfaces/thing/thing-settings.interface';
import {ParkAttributesInterface} from '@app/app/shared/interfaces/park-attributes.interface';

@Component({
  templateUrl: './park-info-view.html',
  selector: 'park-info-view'
})

export class ParkInfoViewComponent {
  @Input() public attributes: ParkAttributesInterface;
  @Input() public parkMeta: any;
  @Output() getSearchStatusChange = new EventEmitter<boolean>();
  @Input() getSearchStatus: boolean;
  public availableLanguages = {
    en: {name: 'English'},
    fr: {name: 'French'},
    ru: {name: 'Russian'}
  };

  public setEditMode() {
    this.getSearchStatusChange.emit(true);
  }

  public setEditModeForNotifications() {
    this.getSearchStatusChange.emit(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/settings/info/park-info-view.component.ts